import transport from '../utils/axios';

// Storefront Public APIs
export const getNavigation = () => transport.get('/navigation'); // 1
export const getHome = () => transport.get('/home'); // 1
export const getHomeSections = () => transport.get('/home-sections'); // 1
export const getHomeSectionByCode = (code) => transport.get(`/home-sections/${code}`); // 1 
export const searchProducts = (params) => transport.get('/products/search', { params });
export const getProductsByCategorySlug = (slug, params = {}) => transport.get(`/categories/${slug}/products`, { params });
export const getFilterOptions = () => transport.get('/filter-options');
export const getPages = () => transport.get('/pages');
export const getPageBySlug = (slug) => transport.get(`/pages/${slug}`);
export const getProductBySlug = (slug) => transport.get(`/products/${slug}`);

// Blog/Posts APIs (Public)
export const getPosts = (params = {}) => transport.get('/storefront/posts', { params });
export const getPostBySlug = (slug) => transport.get(`/storefront/posts/${slug}`);
export const getFeaturedPosts = (params = {}) => transport.get('/storefront/posts/featured', { params });
export const getRecentPosts = (params = {}) => transport.get('/storefront/posts/recent', { params });
export const getRelatedPosts = (slug, params = {}) => transport.get(`/storefront/posts/${slug}/related`, { params });
export const getPostCategories = () => transport.get('/storefront/post-categories');
export const getPostTags = () => transport.get('/storefront/post-tags');

// Cart APIs (for authenticated users)
export const getCart = () => transport.get('/cart');
export const addToCart = (data) => transport.post('/cart/items', data);
export const updateCartItem = (itemId, data) => transport.put(`/cart/items/${itemId}`, data);
export const removeFromCart = (itemId) => transport.delete(`/cart/items/${itemId}`);
export const validateCart = () => transport.get('/cart/validate');
export const applyCoupon = (code) => transport.post('/cart/coupon/apply', { code });
export const removeCoupon = () => transport.delete('/cart/coupon');
export const mergeCart = (data) => transport.post('/cart/merge', data);

// Checkout APIs (for authenticated users)
export const getCheckoutSummary = () => transport.get('/checkout/summary');
export const getShippingMethods = () => transport.get('/checkout/shipping-methods');
export const placeOrder = (data) => transport.post('/checkout/place-order', data);

// Customer Profile APIs (for authenticated users)
export const getCustomerProfile = () => transport.get('/me/profile');
export const getCustomerAddresses = () => transport.get('/me/addresses');
export const createCustomerAddress = (data) => transport.post('/me/addresses', data);
export const updateCustomerAddress = (id, data) => transport.put(`/me/addresses/${id}`, data);
export const deleteCustomerAddress = (id) => transport.delete(`/me/addresses/${id}`);
export const setDefaultShippingAddress = (id) => transport.post(`/me/addresses/${id}/default-shipping`);
export const setDefaultBillingAddress = (id) => transport.post(`/me/addresses/${id}/default-billing`);
export const startPayment = (data, config = {}) => transport.post('/payments/start', data, config);
export const retryPayment = (paymentId, config = {}) => transport.post(`/payments/${paymentId}/retry`, undefined, config);
export const getCustomerOrders = (params = {}) => transport.get('/me/orders', { params });
export const getCustomerOrderById = (id) => transport.get(`/me/orders/${id}`);
export const cancelCustomerOrder = (id, data = {}) => transport.post(`/me/orders/${id}/cancel`, data);
export const getCustomerOrderInvoice = (id, params = {}) =>
    transport.get(`/me/orders/${id}/invoice`, { params, responseType: 'blob' });
export const getCustomerWishlist = () => transport.get('/me/wishlist');
export const addToWishlist = (data) => transport.post('/me/wishlist', data);
export const removeFromWishlist = (productId) => transport.delete(`/me/wishlist/${productId}`);
export const clearWishlist = () => transport.delete('/me/wishlist');
export const toggleWishlistItem = (productId) => transport.post('/me/wishlist/toggle', { product_id: productId });
export const checkWishlistItem = (productId) => transport.get(`/me/wishlist/check/${productId}`);
export const getWishlistCount = () => transport.get('/me/wishlist/count');
